import { useNavigation } from '@react-navigation/native';
import Color from 'color';
import { memo, ReactNode, useCallback } from 'react';
import {
  StyleProp,
  TouchableWithoutFeedback,
  View,
  ViewStyle,
} from 'react-native';

const kBgColor = Color.rgb('#282828').alpha(0.95).string();

export const ModalScreen = memo(
  ({
    autoClose,
    children,
    style,
  }: {
    children?: ReactNode;
    autoClose?: boolean;
    style?: StyleProp<ViewStyle>;
  }) => {
    const navigation = useNavigation();

    const onClose = useCallback(() => {
      if (autoClose !== false) {
        navigation.goBack();
      }
    }, [autoClose, navigation]);
    return (
      <TouchableWithoutFeedback onPress={onClose}>
        <View
          css={`
            flex: 1;
            background-color: ${kBgColor};
          `}
          style={style}
        >
          {children}
        </View>
      </TouchableWithoutFeedback>
    );
  },
);
